import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const FineTuneWrapper = styled.div`
  padding: 3rem;
  display: flex;
  flex-direction: column;
  @media (max-width: ${TABLET_WIDTH}px) {
    padding: 0;
  }
  .back {
    width: 100%;
    margin: 2rem 1rem;
    font-size: 1.6rem;
    i {
      padding: 0rem 1rem;
      font-size: 1.6rem;
      cursor: pointer;
    }
  }
  .top_button {
    width: 100%;
    margin: 2rem 1rem;
  }
  .top {
    width: 100%;
    margin: 2rem;
  }
  .bottom {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-top: 2rem;
    flex-wrap: wrap;
  }
  .progress {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
  }
`;

export const YourProgress = styled.div`
  width: 65%;
  min-width: 50rem;
  padding: 3rem;
  margin: 1rem;
  border-radius: 2.2rem;
  background: white;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  @media (max-width: ${TABLET_WIDTH}px) {
    padding: 1rem;
    min-width: 90%;
  }
  .title {
    font-size: 1.8rem;
    font-weight: bold;
    margin: 1rem;
  }
  .subtitle {
    font-size: 1.6rem;
    margin: 1rem;
  }
`;

export const ProgressSerendipity = styled.div`
  width: 40rem;
  max-width: 80%;
  height: 1rem;
  z-index: 4;
  border-radius: 2rem;
  background: #DBDBDB;
  position: relative;
  margin: 2rem 1rem;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: ${props => `${props.progress}rem`};
    height: 1rem;
    z-index: 4;
    border-radius: 2rem;
    background: #2680EB;
  }
`;

export const YourProfile = styled.div`
  width: 30%;
  min-width: 35rem;
  margin: 1rem;
  border-radius: 2.2rem;
  background: white;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: ${TABLET_WIDTH}px) {
    padding: 1rem;
    min-width: 90%;
  }
  .name {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 2rem 0.5rem;
  }
`;

export const StartButton = styled.button`
  width: 21rem;
  height: 5rem;
  padding: 2rem;
  border-radius: 4rem;
  background: #2680EB;
  color: white;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  i {
    font-size: 2rem;
    margin-right: 2rem;
  }
`;

export const ProfilePic = styled.div`
  background: ${props => `url(${props.img})`};
  height: 10rem;
  width: 10rem;
  background-size: cover;
  border-radius: 100%;
  margin-top: 2rem;
`;

export const TitleBack = styled.div`
  .title_create {
    margin: 1% 0;
    text-align: left;

    div {
      display: inline-block;
      font-family: ${RalewayFont.regularFamily};
      font-size: 2.2rem;
      margin: 1%;
    }

    img {
      display: inline-block;
      margin-left: 1%;
      cursor: pointer;
    }
`;


export const Progress = styled.div`
  width: 30rem;
  max-width: 80%;
  height: 6rem;
  margin: 0.5rem 2rem;
  z-index: 4;
  border-radius: 1rem;
  background: #F6F7F9;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  @media (max-width: ${TABLET_WIDTH}px) {
    max-width: 90%;
    width: 90%;
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: ${props => `${props.progress}rem`};
    height: 6rem;
    z-index: 4;
    border-radius: 1rem;
    background: ${props => (props.finish ? '#E5E5E5' : '#C2DEFF')};
    @media (max-width: ${TABLET_WIDTH}px) {
      width: ${props => `${90 * (props.progress / 30)}%`};
      width: ${props => (props.finish ? '100%' : '')};
    }
  }

  .title {
    z-index: 10;
    padding: 1rem;
    width: 50%;
    font-size: 1.3rem;
    left: 4rem;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  img {
    width: 3rem;
    height: 3rem;
    margin: 1rem;
    z-index: 10;
  }
  .percentage {
    position: absolute;
    right: 0;
    padding: 1rem;
    font-size: 1.2rem;
    font-weight: 600;
    z-index: 100;
  }
  .new {
    position: absolute;
    right: 0;
    padding: 1rem;
    font-size: 1.2rem;
    font-weight: 600;
    color: #FFA200;
  }
`;

export const ViewProfile = styled.div`
    margin: 2rem;
    border-radius: 2rem;
    font-size: 1.5rem;
    cursor: pointer;
    border: 0px;
    color: #fff;
    background-color: #1976d2;
    font-weight: 600;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    padding: 1rem 2rem;
    letter-spacing: 1px;
`;



// WEBPACK FOOTER //
// ./src/routes/FineTune/components/styles.js